import { SEVERITY_UI, alertStateUi } from '@baseline/shared';

import { StatusIcon } from './icons.js';

import type { AlertState, Severity } from '@baseline/shared';

/** Prototype `statusPill`: the label and class come from `shared/ui/labels.ts`. */
export function StatusPill({ state }: { state: AlertState }) {
  const ui = alertStateUi(state);
  return (
    <span className={`pill ${ui.pillClass}`}>
      <StatusIcon status={ui.icon} />
      {ui.label}
    </span>
  );
}

/** Prototype `sevPill`. */
export function SeverityPill({ level }: { level: Severity }) {
  const ui = SEVERITY_UI[level];
  return <span className={`pill ${ui.pillClass}`}>{ui.label}</span>;
}
